import { skipToken } from '@reduxjs/toolkit/dist/query'
import { constructAndMergeWithDashboardAnalyticsCategories } from 'modules/Teams/store/selectors'
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getSelectedTeam,
  peerReviewDashboardActions
} from './peerReviewAnalytics'
import { useGetPeerGroupAnalyticsByTeamNameQuery } from './peerReviewAnalyticsApi'

export const usePeerReviewAnalytics = () => {
  const dispatch = useDispatch()
  const selectedTeam = useSelector(getSelectedTeam)
  const setSelectedTeam = useCallback(
    (teamName?: string) => {
      dispatch(peerReviewDashboardActions.setSelectedTeam(teamName))
    },
    [dispatch]
  )
  const queryState = useGetPeerGroupAnalyticsByTeamNameQuery(
    selectedTeam ? { teamName: selectedTeam } : skipToken
  )

  const { currentData: data, isFetching, error } = queryState

  const team = useMemo(
    () =>
      data?.teamWithRank &&
      constructAndMergeWithDashboardAnalyticsCategories(data?.teamWithRank),
    [data?.teamWithRank]
  )

  const pwm = useMemo(
    () =>
      data?.pwm &&
      constructAndMergeWithDashboardAnalyticsCategories({
        team: data?.pwm
      }),
    [data?.pwm]
  )

  const division = useMemo(
    () =>
      data?.division &&
      constructAndMergeWithDashboardAnalyticsCategories({
        team: data?.division
      }),
    [data?.division]
  )

  const peers = useMemo(
    () =>
      data?.peers &&
      constructAndMergeWithDashboardAnalyticsCategories({
        team: data?.peers
      }),
    [data?.peers]
  )

  return {
    selectedTeam,
    setSelectedTeam,
    queryState,
    isFetching,
    error,
    enhancedData: team && {
      teamName: data?.teamWithRank?.team?.teamName,
      asOfDate: data?.meta?.asOfDate,
      meta: data?.meta,
      peerGroupDefinition: data?.peerGroupDefinition,
      team,
      pwm,
      division,
      peers
    }
  }
}
